const USER_PROFILE_PAGE_CONTANTS = {
    SIGNIN_PAGE: 'MOBILESIGNINUP',
    SIGNUP_PAGE: 'MOBILESIGNINUP',
    RESET_PAGE: 'RESET',
    RESET_CONFIRMATION_PAGE: 'RESET_CONFIRMATION',
    SIGNEDIN_USER_PAGE: 'SIGNEDIN_USER',
    SIGNUP_FORM_PAGE: 'SIGNUP_FORM',
    VERIFY_MOBILE_NUMBER: 'VERIFY_MOBILE_NUMBER',
    EMAIL_LINKED: 'EMAIL_LINKED',
    VERIFY_EMAIL: 'VERIFY_EMAIL',
    LINK_ACCOUNTS: 'LINK_ACCOUNTS',
    SIGNIN_EMAIL: 'SIGNIN_EMAIL',
    EMAIL_MOBILE_LINKED: 'EMAIL_MOBILE_LINKED',
    LINK_SUCCESS: 'LINK_SUCCESS',
    LOADER: 'LOADER',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    EMAIL_LINKED_PERSONAL_DETAILS: 'EMAIL_LINKED_PERSONAL_DETAILS',
}

export default USER_PROFILE_PAGE_CONTANTS
